import { GadgetSystemDominionId } from "../../database/DominionLiterals";
import { FieldType } from "../../type-system/FieldType";
import {
  ShopifyCatalogKey,
  ShopifyCompanyLocationCatalogKey,
  ShopifyCompanyLocationCatalogToCatalogKey,
  ShopifyCompanyLocationCatalogToCompanyLocationKey,
  ShopifyCompanyLocationCatalogToShopKey,
  ShopifyCompanyLocationKey,
  ShopifyShopKey,
} from "./keys";
import { ShopifyApiVersion } from "./ShopifyApiVersion";
import { ShopifyDominion } from "./ShopifyDominion";
import { buildConnectionSpec, ConnectionModelSpecVersion } from "./ShopifyMetadata";

const specs: ConnectionModelSpecVersion = {
  key: ShopifyCompanyLocationCatalogKey,
  "2024-04": {
    name: "Shopify Company Location Catalog",
    graphQLTypename: "CompanyLocationCatalog",
    fields: [
      {
        name: "ID",
        key: `${ShopifyCompanyLocationCatalogKey}-system-id`,
        fieldType: FieldType.ID,
        dominionID: GadgetSystemDominionId,
      },
      {
        name: "Catalog",
        fieldType: FieldType.BelongsTo,
        key: ShopifyCompanyLocationCatalogToCatalogKey,
        configuration: {
          relatedModelKey: ShopifyCatalogKey,
        },
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "catalogId",
            skipGraphQLSelection: true,
          },
        },
      },
      {
        name: "Company Location",
        fieldType: FieldType.BelongsTo,
        key: ShopifyCompanyLocationCatalogToCompanyLocationKey,
        configuration: {
          relatedModelKey: ShopifyCompanyLocationKey,
        },
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "companyLocationId",
            skipGraphQLSelection: true,
          },
        },
      },
      {
        name: "Shop",
        fieldType: FieldType.BelongsTo,
        key: ShopifyCompanyLocationCatalogToShopKey,
        configuration: {
          relatedModelKey: ShopifyShopKey,
        },
      },
    ],
    syncConfig: {
      type: "graphql_sublist",
      parent: "companyLocations",
      resource: "companyLocation.catalogs",
      additionalSelection: "id",
    },
  },
};

export const ShopifyCompanyLocationCatalog = ({
  apiVersion,
  frameworkVersionConstraint,
  webhookTopicsForModel,
}: {
  apiVersion: ShopifyApiVersion;
  frameworkVersionConstraint?: string;
  webhookTopicsForModel?: string[];
}) => buildConnectionSpec(specs, apiVersion, frameworkVersionConstraint, webhookTopicsForModel);
